import {NgModule} from '@angular/core';
import {CmsPageGuardService} from '@spartacus/storefront';

import {AimoCmsPageGuardService} from './aimo-cms-page-guard.service';
import {AimoOccCmsPageAdapter} from "./aimo-occ-cms-page.adapter";
import {OccCmsPageAdapter} from "@spartacus/core";

@NgModule({
    providers: [
        {
            provide: CmsPageGuardService,
            useExisting: AimoCmsPageGuardService,
        },
        {
            provide: OccCmsPageAdapter,
            useExisting: AimoOccCmsPageAdapter
        }
    ],
})
export class AimoCMSServiceModule {
}
